import { useState, useEffect } from "react";
import { Panel, DefaultButton, PrimaryButton } from "../../fluent";
import { Column } from "./Column";
import { Grid } from "./Grid";
import { Row } from "./Row";
import React from "react";
export const StandarPanel = (props) => {
    const [show, setShow] = useState(props.isOpen);
    const [acceptText, setAcceptText] = useState(props.acceptButtonText);
    useEffect(() => {
        setShow(props.isOpen);
        setAcceptText(props.acceptButtonText);
    }, [props]);
    const showAcceptButton = props.hideAcceptButton == null || typeof props.hideAcceptButton === 'boolean' && !props.hideAcceptButton;
    return React.createElement(Panel, { isOpen: show, type: props.type, headerText: props.headerText, hasCloseButton: false, onRenderFooterContent: () => (React.createElement(Grid, null,
            React.createElement(Row, null,
                React.createElement(Column, { size: 12, style: { textAlign: 'right' } }, typeof props.onRenderFooter === 'function'
                    ? props.onRenderFooter()
                    : React.createElement(React.Fragment, null,
                        showAcceptButton && React.createElement(PrimaryButton, { text: acceptText || 'Aceptar', onClick: props.onAccept }),
                        React.createElement(DefaultButton, { text: props.closeButtonText || 'Volver', onClick: props.onClose })))))), isFooterAtBottom: true }, props.onRender());
};
